import { createActionTypes } from "../../../utils";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    ...createActionTypes("DOCUMENTS_C", "SAVE_DOCUMENTS_C"),
    ...createActionTypes("DOCUMENTS_C", "DELETE_DOCUMENTS_C"),
};
